/*/
 * Swiper v8
/*/
	import Swiper, { Autoplay, Lazy, Navigation } from 'swiper';

	const siteSwiperGallery = document.querySelectorAll('[swiper-service-gallery]')

	if (siteSwiperGallery.length > 0) {
		siteSwiperGallery.forEach(e => {
			const count = e.querySelectorAll('.swiper-slide').length > 1 ? true : false

			const siteSwiperTimeline = new Swiper(e, {
				modules: [Navigation, Lazy, Autoplay],
				loop: count,
				speed: 1000,
				threshold: 5,
				autoHeight: false,
				grabCursor: true,
				navigation: {
					prevEl: e.querySelector('.swiper-prev'),
					nextEl: e.querySelector('.swiper-next'),
				},
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 1,
				},
				// autoplay: {
				// 	delay: 3500,
				// 	disableOnInteraction: true,
				// }
			})
		})
	}
